import { render, staticRenderFns } from "./Merchandise.vue?vue&type=template&id=1c23b1cf&scoped=true"
import script from "./Merchandise.vue?vue&type=script&lang=js"
export * from "./Merchandise.vue?vue&type=script&lang=js"
import style0 from "./Merchandise.vue?vue&type=style&index=0&id=1c23b1cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c23b1cf",
  null
  
)

export default component.exports